module.exports = __webpack_public_path__ + "static/media/logo-coopeuch.2deb8371.svg";